import { CoborrowerBonus, PrimaryBorrowerBonus } from '../../cards/bonus-cards/bonus';
import {
  CoborrowerCommission,
  PrimaryBorrowerCommission
} from '../../cards/bonus-cards/commission';
import {
  CoborrowerEmploymentLength,
  PrimaryBorrowerEmploymentLength
} from '../../cards/bonus-cards/employment-length';
import {
  CoborrowerFunctionalArea,
  PrimaryBorrowerFunctionalArea
} from '../../cards/bonus-cards/functional-area';
import { Branch, Card } from '../../components/deck';

const employmentLengthCard = {
  borrower: PrimaryBorrowerEmploymentLength,
  coborrower: CoborrowerEmploymentLength
};

const functionalAreaCard = {
  borrower: PrimaryBorrowerFunctionalArea,
  coborrower: CoborrowerFunctionalArea
};

const bonusCard = {
  borrower: PrimaryBorrowerBonus,
  coborrower: CoborrowerBonus
};

const commissionCard = {
  borrower: PrimaryBorrowerCommission,
  coborrower: CoborrowerCommission
};

/**
 * Card for collecting commission.
 *
 * @param {*} borrowerKey primary or coborrower
 */
const CommissionBranch = (borrowerKey) => Card(commissionCard[borrowerKey]);

/**
 * Workflow for collecting bonus info and commission info
 *   if it is also selected.
 *
 * @param {*} borrowerKey primary or coborrower
 */
const BonusBranch = (borrowerKey) =>
  Card(
    bonusCard[borrowerKey],
    Branch({ commissionBranch: CommissionBranch(borrowerKey) }, ({ model }) => {
      // If the user also has a commission...
      if (model.getIn([borrowerKey, 'commission'])) {
        return 'commissionBranch';
      }
      return null;
    })
  );

/**
 * Workflow for collecting commisison or bonus info when a user
 *   has changed jobs in the past two years.
 *
 * @param {*} borrowerKey primary or coborrower
 */
export const FunctionalAreaBranch = (borrowerKey) =>
  Card(
    functionalAreaCard[borrowerKey],
    Branch(
      {
        bonusBranch: BonusBranch(borrowerKey),
        commissionBranch: CommissionBranch(borrowerKey)
      },
      ({ model }) => {
        // If there is continuity between roles, collect info.
        if (model.getIn([borrowerKey, 'continuityInRole'])) {
          if (model.getIn([borrowerKey, 'bonus'])) {
            return 'bonusBranch';
          }
          if (model.getIn([borrowerKey, 'commission'])) {
            return 'commissionBranch';
          }
        }
        // ... otherwise back out.
        return null;
      }
    )
  );

/**
 * Workflow for collecting commisison or bonus info.
 *
 * @param {*} borrowerKey primary or coborrower
 */
const ExtraIncomeBranch = (borrowerKey) =>
  Card(
    employmentLengthCard[borrowerKey],
    Branch(
      {
        bonusBranch: BonusBranch(borrowerKey),
        commissionBranch: CommissionBranch(borrowerKey),
        functionalAreaBranch: FunctionalAreaBranch(borrowerKey)
      },
      ({ model }) => {
        // If the customer has been at their current job for at least two
        //   years, go directly to collect their bonus/commission
        if (model.getIn([borrowerKey, 'twoYearsAtCurrentJob'])) {
          if (model.getIn([borrowerKey, 'bonus'])) {
            return 'bonusBranch';
          }
          if (model.getIn([borrowerKey, 'commission'])) {
            return 'commissionBranch';
          }
        } else {
          // If the customer has not been in their current job for at least
          //   two years, ask if their functional area is similar.
          return 'functionalAreaBranch';
        }
        return null;
      }
    )
  );

export default ExtraIncomeBranch;



// WEBPACK FOOTER //
// ./src/decks/branches/extra-income.js